
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ISpaceStationBlog, IStaticDataLoadingStatus, ISpaceStationBlogEntry } from "../store-services/staticdata.types";

@Component({
  filters: {
    time_str(value: string) {
      let d_fmt = new Intl.DateTimeFormat("en-US", {dateStyle: "medium", timeStyle: "short", })
      let d = new Date(value || 0)
      return `${d_fmt.format(d)}`
    } 
  }
})
export default class SpaceStationBlogComponent extends Vue {
  @Prop()
  value!: boolean;
  currentEntry: ISpaceStationBlogEntry = {} as ISpaceStationBlogEntry;
  showMoreDialog: boolean = false;
  
  get show(): boolean {
    return this.value
  }
  set show(value: boolean) {
    this.$emit('input', value)
  }

  get blog(): ISpaceStationBlog {
    return this.$store.getters["staticdata/getSpaceStationBlog"];
  }
  get blogStatus(): IStaticDataLoadingStatus {
    return this.blog.status;
  }
  get blogEntries(): Array<ISpaceStationBlogEntry> {
    return this.blog.content?.data?.entries || [];
  }

  close() {
    this.show = false;
  }

  refresh() {
    this.$store.dispatch("staticdata/updateSpaceStationBlog")
  }

  @Watch("value")
  watchValue(value: boolean) {
    // If re-opened within 5min won't re-request...
    if (value) {
      this.refresh()
    }
  }
}
